export default {
    data() {
        return {   
            imagelist: [],
        }   
    },
    methods: {
        async loadImage(imageUrl, key, height) {
            
            let img;
            const imageLoadPromise = new Promise(resolve => {
                img = new Image();
                img.onload = resolve;
                img.src = imageUrl;
            });

            await imageLoadPromise;
            
            var oImg = new Object();
            oImg.key = key;
            oImg.src = img.src;
            oImg.aspect_ratio = this.getAspectRatio(img.src); 
            oImg.width = this.getWidthByNewHeight(img.src, height);
            this.imagelist.push(oImg);

            //console.log("instance", JSON.stringify(this.imagelist));

        },  
        getImgAspectRatio(key){
            var idx = this.findImageEntryWithAttr(this.imagelist, 'key', key);
            if(idx != -1) {
                return this.imagelist[idx].aspect_ratio;
            }
        },
        getImgSrc(key){
            var idx = this.findImageEntryWithAttr(this.imagelist, 'key', key);
            if(idx != -1) {
                return this.imagelist[idx].src;
            }
        },
        getImgWidth(key){
            var idx = this.findImageEntryWithAttr(this.imagelist, 'key', key);
            if(idx != -1) {
                return this.imagelist[idx].width;
            }
        },
        findImageEntryWithAttr(array, attr, value) {
            for(var i = 0; i < array.length; i += 1) {
                if(array[i][attr] === value) {
                    return i;
                }
            }
            return -1;
        },               
        getAspectRatio(image){

            var img = new Image();
            img.src = image;
            
            if(img.naturalHeight == 0 && img.naturalHeight == 0){
                console.log('vreemd probleem dient zich hier aan');                
            }            
            
            var ar = this.aspect_ratio(img.naturalWidth/img.naturalHeight, 50);            
            return ar[0]/ar[1];
            
        },
        getWidthByNewHeight(image, newheight){
            var img = new Image();
            img.src = image; 
            var gcd = img.naturalHeight / newheight;
            return (img.naturalWidth / gcd) + 3; // small correction for rounding differences
        },
        getHeightByNewWidth(image, newwidth){
            var img = new Image();
            img.src = image; 
            var gcd = img.naturalWidth / newwidth;
            return (img.naturalHeight / gcd) + 3; // small correction for rounding differences
        },
        aspect_ratio(val, lim) {

            var lower = [0, 1];
            var upper = [1, 0];
            var loop = true;
        
            //while (true) {
            do {    
                var mediant = [lower[0] + upper[0], lower[1] + upper[1]];
        
                if (val * mediant[1] > mediant[0]) {
                    if (lim < mediant[1]) {
                        return upper;
                    }
                    lower = mediant;
                } else if (val * mediant[1] == mediant[0]) {
                    if (lim >= mediant[1]) {
                        return mediant;
                    }
                    if (lower[1] < upper[1]) {
                        return lower;
                    }
                    return upper;
                } else {
                    if (lim < mediant[1]) {
                        return lower;
                    }
                    upper = mediant;
                }
            } while(loop);
        }        
    }
}    